import React from "react";
import { Clock, Phone, Mail, ChevronLeft } from "lucide-react";

function OurLocation() {
  return (
    <section
      className="w-full mt-8 md:mt-10 lg:mt-12 bg-white border-b border-zinc-200"
      dir="rtl"
    >
      {/* Centered Content Container */}
      <div className="container max-w-7xl mx-auto px-4 sm:px-5 md:px-6 lg:px-8 py-8 md:py-10 lg:py-12">
        {/* Title */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-blue-900 mb-6 md:mb-8 lg:mb-10 leading-tight">
          مكتبنا الإقليمي الرئيسي
        </h2>

        {/* Content Grid */}
        <div className="flex flex-col lg:flex-row items-start gap-6 md:gap-8 lg:gap-10">
          {/* Right Side: Text & Info */}
          <div className="w-full lg:w-1/2 flex flex-col">
            <p className="text-sm sm:text-base md:text-lg text-right text-zinc-700 leading-relaxed mb-6 md:mb-8">
              مؤسسة الخير تضرب جسور التعاون الإنساني عبر مكاتبها الدولية، حيث
              يعتبر مكتبها الإقليمي الرئيسي في إسطنبول، تركيا، نقطة تلاقٍ للجهود
              الإنسانية وتقديم الدعم للمحتاجين.
            </p>

            {/* Info Items */}
            <div className="space-y-4 md:space-y-5 lg:space-y-6">
              {/* Work Hours */}
              <div className="flex items-center gap-3 md:gap-4 group">
                <div className="flex shrink-0 justify-center items-center w-10 h-10 md:w-11 md:h-11 lg:w-12 lg:h-12 bg-blue-500 rounded-full text-white shadow-md">
                  <Clock
                    size={16}
                    className="md:w-[18px] md:h-[18px] lg:w-5 lg:h-5"
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-base md:text-lg lg:text-xl font-bold text-zinc-800">
                    مواعيد العمل
                  </span>
                  <span className="text-xs sm:text-sm md:text-base font-medium text-zinc-600">
                    من الساعة 10:00 ص حتى 04:00 م - يومياً عدا الجمعة
                  </span>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-center gap-3 md:gap-4 group">
                <div className="flex shrink-0 justify-center items-center w-10 h-10 md:w-11 md:h-11 lg:w-12 lg:h-12 bg-blue-500 rounded-full text-white shadow-md">
                  <Phone
                    size={16}
                    className="md:w-[18px] md:h-[18px] lg:w-5 lg:h-5"
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-base md:text-lg lg:text-xl font-bold text-zinc-800">
                    هاتف رقم
                  </span>
                  <span className="text-xs sm:text-sm md:text-base font-medium text-zinc-600 dir-ltr text-right font-sans break-all">
                    +44 7360931094 — +44 7360931094
                  </span>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center gap-3 md:gap-4 group">
                <div className="flex shrink-0 justify-center items-center w-10 h-10 md:w-11 md:h-11 lg:w-12 lg:h-12 bg-blue-500 rounded-full text-white shadow-md">
                  <Mail
                    size={16}
                    className="md:w-[18px] md:h-[18px] lg:w-5 lg:h-5"
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-base md:text-lg lg:text-xl font-bold text-zinc-800">
                    البريد الإلكتروني
                  </span>
                  <span className="text-xs sm:text-sm md:text-base font-medium text-zinc-600 break-all">
                    info@alkhairmiddleeast.org
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Left Side: Map */}
          <div className="w-full lg:w-1/2">
            <div className="h-[250px] sm:h-[300px] md:h-[350px] lg:h-[377px] w-full border-white border-[3px] sm:border-[4px] md:border-[5px] shadow-md md:shadow-lg overflow-hidden rounded-xl sm:rounded-2xl ring-1 ring-zinc-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27211.639806607174!2d34.441600460625665!3d31.511661639346656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14fd7f205da3a9cd%3A0xabc6cfdd4db76245!2z2LTYsdmD2Kkg2YjZitioINmE2KfZitixINmE2K7Yr9mF2KfYqiDYp9mE2YjZitioIHdlYmFseWVyLmNv!5e0!3m2!1sen!2str!4v1708598250523!5m2!1sen!2str"
                className="w-full h-full border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Office Location Map"
              />
            </div>
          </div>
        </div>

        {/* View More Button */}
        <div className="flex justify-center mt-8 md:mt-10 lg:mt-12">
          <button className="flex items-center gap-2 px-4 sm:px-5 md:px-6 py-2 md:py-2.5 text-xs sm:text-sm font-bold bg-white rounded-lg border border-gray-300 shadow-sm text-neutral-900 hover:bg-gray-50 hover:border-blue-500 hover:text-blue-600 transition-all active:scale-95">
            <span>عرض المزيد</span>
            <ChevronLeft size={14} className="md:w-4 md:h-4" />
          </button>
        </div>
      </div>
    </section>
  );
}

export default OurLocation;
